import React from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { optionStyles, locale } from '../customize';
import { scrollToTop } from 'src/utils/Utils';

export default function ShowClientStep({ cookie, setTutorialStep1 }) {
    const { t } = useTranslation()
    const { run, stepIndex, tourCompleted, type } = cookie

    const checkLocationPath = (target) => {
        return window.location.pathname == '/clients' ? target : '.NotFoundClass'
    }

    const step = [
        {
            target: checkLocationPath(".PrimaryPanel__base--BkUR4:nth-child(1)"),
            content: t('features.GuideTour.ClientInfoStep.ShowCliectStep.0'),
            placement: 'auto',
            disableBeacon: true,
        },
        {
            target: checkLocationPath(".PrimaryPanel__base--BkUR4:nth-child(1) .PrimaryPanel__heading--8TG3B span"),
            content: t('features.GuideTour.ClientInfoStep.ShowCliectStep.1'),
            placement: 'auto',
        },
        {
            target: checkLocationPath(".PrimaryPanel__base--BkUR4:nth-child(3)"),
            content: t('features.GuideTour.ClientInfoStep.ShowCliectStep.2'),
            placement: 'auto',
        },
    ];

    const setStepIndex = (newIndex) => {
        setTutorialStep1({ run, stepIndex: newIndex, tourCompleted, type })
    }

    const setTourCompleted = () => {
        scrollToTop();
        setTutorialStep1({ run: false, stepIndex: 0, tourCompleted: true, type: 'next' })
    }

    const handleCallback = data => {
        const { action, index, lifecycle, type } = data;
        const newIndex = index + (action === 'prev' ? -1 : 1);

        if (action === 'skip') {
            setTourCompleted()
        }
        else if (type === 'step:after' && index === 0) {
            action === 'next' && setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 1) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 2) {

            if (action == "prev") setStepIndex(newIndex)
            else if (lifecycle === 'complete') {
                setTourCompleted()
            }
        }
    };

    return (
        <Joyride
            steps={step}
            run={run}
            stepIndex={stepIndex}
            callback={handleCallback}
            styles={optionStyles}
            locale={locale(t)}
            continuous
            scrollToFirstStep
            hideCloseButton
            showProgress
            showSkipButton
            disableOverlayClose
        />
    )
}
